export default {
  getFiltersData(state) {
    return function (dataName) {
      return _.get(state, `filtersData.${dataName}`, null)
    }
  },
  getFiltersDataById(state) {
    return function (dataName, dataId) {
      return _.find(_.get(state, `filtersData.${dataName}`, null), ['id', dataId])
    }
  },
  getFiltersConfig(state) {
    return function (name) {
      return _.get(state, `filtersConfig.${name}`, null)
    }
  },
}
